export const themeConfig = {
  extend: {
    colors: {
      white: '#FFFFFF',
      q: {
        cr: {
          red: {
            primary: '#ED3624',
            darker: '#D92E1F',
          },
          gray: {
            lighter: '#E6E6E6',
            primary: '#3D3D3D',
            darker: '#2B2B2B',
          },
        },
      },
      joe: {
        cr: {
          blue: {
            primary: '#1e64c8',
            darker: '#14328c',
          },
          rose: {
            primary: '#dc3c96',
          },
        },
      },
      willy: {
        cr: {
          black: {
            primary: '#141414',
          },
          gray: {
            primary: '#E7EEE1',
            alt: '#F4F3EF',
          },
          blue: {
            primary: '#087E8B',
          },
        },
      },
    },
  },
}

export const colors = themeConfig.extend.colors
